import classNames from "classnames";
import React from "react";

import { Col } from "@components/General/Grid/col.component";

import "./resultField.scss";

export type ResultFieldProps = {
    copy: string;
    copyPostfix?: string;
    value: any;
    unit?: string;
    sup?: number;
    sm?: number;
    md?: number;
    lg?: number;
    className?: string;
    children?: React.ReactNode;
};

const ResultField = ({
    copy,
    copyPostfix,
    value,
    unit,
    sup,
    sm,
    md,
    lg,
    className,
    children,
}: ResultFieldProps) => {
    return (
        <Col
            sm={sm}
            md={md}
            lg={lg}
            className={classNames("calculator-result-field", className)}
        >
            <div className={"calculator-result-field__copy"}>
                {children}
                {copy}
                {copyPostfix && (
                    <div className={"calculator-result-field__copy-postfix"}>
                        {copyPostfix}
                    </div>
                )}
            </div>
            <div className={"calculator-result-field__value"}>
                {value.toString().replace(".", ",")}
                <div className={"calculator-result-field__value-unit"}>
                    {unit}
                    {unit && sup && <sup>{sup}</sup>}
                </div>
            </div>
        </Col>
    );
};

export default ResultField;
